import { PlatformCost } from '@/assets/icons/PlatformCost';
import Calendar from '@/assets/icons/calendar.svg';
import { Elements } from '@/components/elements';
import WhiteLabelIcon from '@/assets/icons/WhiteLabelIcon.svg';
import IncreaseRevenueIcon from '@/assets/icons/IncreaseRevenueIcon.svg';
import Maintain from '@/assets/icons/MaintainAOR.svg';
import { Link } from 'react-router';
import Image from 'next/image';

export const BuildIchra = () => {
    return (
        <section
            className="overflow-hidden px-5 pt-20 pb-20 md:px-10 lg:px-[79px] bg-brand-50"
        >
            <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center gap-4">
                <Elements.Title
                    title="Build ICHRAs in Months Minutes"
                    type="h1"
                    className="max-w-[350px] text-center text-brand-700 md:max-w-none"
                    highlights={[
                        {
                            text: 'Months',
                            className: 'text-gray-400 font-bold line-through decoration-2',
                        },
                    ]}
                />
                <Elements.Description
                    description=" Sell your own white-labeled ICHRA product and differentiate yourself in the market. Maintain control over your client relationships while offering cutting-edge benefits technology, and maximized earnings."
                    type="medium"
                    className="max-w-[720px] text-center text-gray-900"
                />

                <div className="mb-4 ml-0 inline-block rounded-2xl bg-transparent shadow-[16px_16px_16px_rgba(0,0,0,0.15)]">
                    <div className="w-full max-w-[624px] [&>svg]:h-auto [&>svg]:w-full">
                        <PlatformCost />
                    </div>
                </div>

                <Elements.Title
                    title="Grow Revenue & Profit Margin as AOR/BOR"
                    type="h3"
                    className="mb-5 text-center text-gray-900"
                />

                <div className="mx-auto mb-[50px] flex w-full max-w-[1200px] flex-col items-center justify-center gap-4 md:mb-[50px] md:flex-row md:items-stretch md:gap-4 lg:justify-between" >
                    <div className="flex w-full max-w-[355px] [&>svg]:h-auto [&>svg]:w-full">
                        <img src={Maintain} alt="Maintain" />
                    </div>
                    <div className="flex w-full max-w-[355px] [&>svg]:h-auto [&>svg]:w-full">
                        <img src={WhiteLabelIcon} alt="White Label" />
                    </div>
                    <div className="flex w-full max-w-[355px] [&>svg]:h-auto [&>svg]:w-full ">
                        <img src={IncreaseRevenueIcon} alt="Increase Revenue" />
                    </div>
                </div>

                <div className="flex items-center justify-center gap-4">
                    <Link to="/demo">
                        <Elements.Button variant="primary" size="lg" className="w-50% md:w-auto">
                            <span className="text-base md:text-xl lg:text-xl">Book a Demo</span>
                            <Image src={Calendar} alt="Calendar" width={20} height={20} />
                        </Elements.Button>
                    </Link>
                </div>
            </div>
        </section>
    );
};
